<app-title-bar></app-title-bar>
<ng-container *ngIf="showFilter">
    <app-grid-filter [dataModel]="filterModel" [filterItems]="filterItems" (onSearch)="onSearchClicked($event)"></app-grid-filter>
</ng-container>
<ng-container *ngIf="showActionBar">
<app-action-bar [actionItems]="actionItems" (onExportToPdf)="exportToPdf($event)" (onExportToExcel)="exportToExcel($event)" (onViewHistory)="onViewHistory($event)" [showExportItems]="showExportItems" [showHistoryItem]="showHistoryItem"></app-action-bar>
</ng-container>
<section class="grid-container">
    <ng-content select="dx-data-grid"></ng-content>
</section>